import * as React from "react";
import styled, { css } from "styled-components";
import { CouponItemProps } from "..";
import { CouponBtn } from "./CouponBtn";
import { px2rem } from "../../../../utils/css";

interface ThreeWrapperProps {
	radio?: number;
	num?: number;
}

// 宽高固定，自动截取
const ThreeWrapper = styled.div`
	display: grid;
	grid-column-gap: ${px2rem(6)};
	grid-row-gap: ${px2rem(9)};
	overflow-x: scroll;
	/** 隐藏滚动条👇 */
	scrollbar-width: none;
	::-webkit-scrollbar {
		width: 0 !important;
		height: 0 !important;
	}
	/** 隐藏滚动条👆 */
	${(props: ThreeWrapperProps) => {
		const { num } = props;
		return css`
			grid-template-columns: repeat(${num}, ${px2rem(140)}); // 设计稿140px，最初版的尺寸
		`;
	}}

	img {
		${(props: ThreeWrapperProps) => {
			return css`
				height: ${px2rem(140 * props.radio)};
			`;
		}}
		width: 100%;
		object-fit: cover;
	}
`;

export const Three = (props: CouponItemProps) => {
	const { coupons = [], ...others } = props;
	let radio = 1;
	const coupon = coupons.length !== 0 ? coupons[0] : null;
	if (coupon) {
		const n = coupon.height && coupon.width;
		radio = n ? Number((coupon.height / coupon.width).toFixed(2)) : 1;
	}
	return (
		<ThreeWrapper num={coupons.length} radio={radio}>
			{coupons.map((ele) => {
				return <CouponBtn key={ele.img} coupon={ele} {...others} />;
			})}
		</ThreeWrapper>
	);
};
